import React from 'react';
import { injectIntl, defineMessages, IntlShape } from 'react-intl';
import Button from '@material-ui/core/Button';
import CopyToClipboard from 'react-copy-to-clipboard';
import TooltipMultiLineText from '../TooltipMultiLineText';
import { IconDuplicate } from '../IconSet';

const messages = defineMessages({
  copyToClipboard: { id: 'copyToClipboard' },
  copyLink: { id: 'copyLink' },
  copiedToClipboard: { id: 'copiedToClipboard' },
});

type Props = {
  rawUrl: string;
}

type ExtendedProps = Props & { intl: IntlShape };

function CopyLinkButton(props: ExtendedProps) {
  const { intl, rawUrl } = props;
  const [linkCopied, setLinkCopied] = React.useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_timeoutHandler, setTimeoutHandler] = React.useState<null | ReturnType<typeof setTimeout>>(null);

  const handleClipboardTooltipClose = () => {
    const tmHandler = setTimeout(() => {
      setLinkCopied(false);
      setTimeoutHandler(null);
    },
    500);
    setTimeoutHandler(tmHandler);
  };


  const onLinkCopied = (): void => {
    setLinkCopied(true);
  };

  let cboardTtipText = intl.formatMessage(messages.copyToClipboard);
  if (linkCopied) {
    cboardTtipText = intl.formatMessage(messages.copiedToClipboard);
  }

  return (
    <TooltipMultiLineText
      placement="top"
      title={cboardTtipText}
      onClose={handleClipboardTooltipClose}
    >

      <CopyToClipboard
        onCopy={onLinkCopied}
        text={rawUrl}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={
            <IconDuplicate size={24} />
          }
        >
          {intl.formatMessage(messages.copyLink)}
        </Button>
      </CopyToClipboard>
    </TooltipMultiLineText>
  );
}
export default (injectIntl(CopyLinkButton));
